var map = {
	"./de/de.colossus.json": "dff3",
	"./de/de.ghosts.json": "ae0c",
	"./de/de.json": "4c74",
	"./de/de.maestro.json": "ec52",
	"./en/en.colossus.json": "8229",
	"./en/en.ghosts.json": "c561e",
	"./en/en.json": "8b2c",
	"./en/en.maestro.json": "1e92",
	"./en/en.stranger.json": "37f6",
	"./es/es.colossus.json": "2662",
	"./es/es.ghosts.json": "bf54",
	"./es/es.json": "a8f2",
	"./es/es.maestro.json": "8e4f",
	"./fr/fr.colossus.json": "9546",
	"./fr/fr.egypt.json": "0751",
	"./fr/fr.festival.json": "4ba3",
	"./fr/fr.ghosts.json": "b765",
	"./fr/fr.json": "b425",
	"./fr/fr.maestro.json": "ed04",
	"./fr/fr.mykonos.json": "b737",
	"./fr/fr.stranger.json": "adc9",
	"./fr/fr.yakuza.json": "9272",
	"./it/it.colossus.json": "dc77",
	"./it/it.egypt.json": "e6c1",
	"./it/it.ghosts.json": "0f70",
	"./it/it.json": "3966",
	"./it/it.maestro.json": "9a92",
	"./it/it.yakuza.json": "e559"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";